
import { Component, Vue } from "vue-property-decorator";
import ContainerFrame from "@/components/ContainerFrame.vue";
import {
  getOperatorContactDataDummy,
  getOperatorFinanceDataDummy,
} from "@/misc/dto_factory";
import {
  Operator,
  OperatorContactData,
  Address,
  OperatorFinanceData,
} from "@/api/dtos/Operator.schema";
import Api from "@/api";
import { min } from "moment";
import router from "@/router";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    ContainerFrame,
  },
})
export default class NewOperatorView extends Vue {
  step = 1;
  contactValid = false;
  addressValid = false;
  financeValid = false;
  skipFinanceData = false;
  showPaypalClientId = false;
  showPaypalClientSecret = false;
  taxValid = false;
  countries = require("@/misc/countries_german.json");
  isTaxable = false;
  allowFeedback = false;

  public readonly contactData: OperatorContactData =
    getOperatorContactDataDummy();

  public readonly financeData: OperatorFinanceData =
    getOperatorFinanceDataDummy();

  async submit(): Promise<void> {
    try {
      const operator = await Api.OperatorsApi.createOperator({
        uuid: "",
        cards: [],
        contact: this.contactData,
        finance: this.skipFinanceData ? null : this.financeData,
        documentSettings: {
          sendMailOnDataprotectionChanged: false,
          sendMailOnGtcChanged: false,
        },
        emailTemplates: [],
        isActive: true,
        allowFeedback: this.allowFeedback,
        platformService: false,
        managers: [],
        owners: [],
        reminderMailSettings: {
          firstReminder: "P1D",
          secondReminder: "PT2H",
        },
      });

      showToast({
        message: "Betreiber erfolgreich angelegt",
        type: "success",
      });
      router.push({
        name: "Betreiber",
        params: {
          operatorUuid: operator.uuid,
        },
      });
    } catch (e) {
      showToast({
        response: getAxiosResponse(e),
        message: "Fehler beim Anlegen des Betreibers",
        type: "error",
      });

      console.error("Failed to create operator:", e);
    }
  }
}
